import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class MapperAPI extends ComponentAPI {
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
    getMap() {
        return this.state.map;
    }
    setMap(map) {
        this.setState({ map });
    }
    /**
     * Add a custom mapping, it uses the function to generate the value that will be stored as *name* param.
     *
     * @param name the name of the property.
     * @param mapper the **pure function** that generates the value.
     */
    addCustomMapping(name, mapper) {
        const customMapping = { ...this.state.customMapping, [name]: mapper };
        this.setState({ customMapping });
    }
    removeCustomMapping(name) {
        const customMapping = { ...this.state.customMapping };
        delete customMapping[name];
        this.setState({ customMapping });
    }
}
export { MapperAPI, };
//# sourceMappingURL=mapper-api.js.map